import React from 'react'

import Header from '../components/Header'
import Hero from '../components/Hero'
import About from '../components/About'
import Product from '../components/Product'
import Footer from '../components/Footer'

function LandingPage() {
  return (
    <>
    <Header/>
    <Hero/>
    <About/>
    <Product/>
    <Footer/>
    </>
  )
}

export default LandingPage